import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alto, gallery} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  box: {
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 24,
    flex: 1,
    marginHorizontal: 1,
    paddingVertical: 2,
  },
  boxUpdated: {
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 24,
    width: 66,
    marginHorizontal: 3,
    marginVertical: 2,
    paddingVertical: 2,
  },
  notFilledBox: {
    borderStyle: 'dashed',
    borderWidth: 1.3,
    borderColor: alto,
    backgroundColor: gallery,
  },
  icon: {
    marginLeft: indent * 0.1,
    fontSize: 6,
    color: 'white',
    alignSelf: 'center',
  },
  content: {
    flexDirection: 'row',
    alignSelf: 'center',
  },
  month: {
    fontWeight: '700',
    paddingRight: indent * 0.1,
  },
  futureMonthCheckboxStyle: {
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: alto,
  },
});
